module.exports = __webpack_public_path__ + "img/nf.5c99fc19.svg";